
import { FormEvent } from "react";
import { Button } from "@/components/ui/button";
import { LoaderCircle, Info, Check, Shield } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { motion } from "framer-motion";
import { useState } from "react";
import { CoApplicantInfoPopup } from "./CoApplicantInfoPopup";

interface LoanInfoNoticesProps {
  isSubmitting: boolean;
  onClick?: (e: FormEvent) => void;
}

export const LoanInfoNotices = ({ 
  isSubmitting, 
  onClick 
}: LoanInfoNoticesProps) => {
  const isMobile = useIsMobile();
  const [coApplicantInfoOpen, setCoApplicantInfoOpen] = useState(false);
  
  return (
    <div className="space-y-4">
      <motion.div 
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="bg-blue-50/70 rounded-lg p-3 text-xs text-blue-700 border border-blue-100/60"
      >
        <div className="flex items-start">
          <Shield className="h-4 w-4 text-blue-500 mr-2 mt-0.5 flex-shrink-0" />
          <div>
            <p className="font-medium mb-1">Tietosuoja ja käsittely</p>
            <div className="space-y-1.5 text-blue-600/90">
              <p className="text-xs">Täyttämällä ja lähettämällä hakemuksen hyväksyt tietojesi käsittelyn tietosuojaselosteen mukaisesti.</p>
              
              <button
                type="button"
                onClick={() => setCoApplicantInfoOpen(true)}
                className="text-blue-600 hover:text-blue-800 hover:underline flex items-center font-medium text-xs mt-1"
              >
                <Info className="h-3.5 w-3.5 mr-1" /> Lisätietoa rinnakkaishakijasta
              </button>
            </div>
          </div>
        </div>
      </motion.div>
      
      {/* Only show this button on mobile AND when a click handler is provided */}
      {isMobile && onClick && (
        <Button 
          type="button"
          onClick={onClick}
          className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-3 text-base transition-all duration-300 transform hover:scale-[1.02] hover:shadow-md rounded-lg font-semibold h-14"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <LoaderCircle className="mr-2 h-5 w-5 animate-spin" />
              Lähetetään...
            </>
          ) : (
            "Vertaile lainatarjouksia"
          )}
        </Button>
      )}
      
      {/* Co-applicant popup */}
      <CoApplicantInfoPopup 
        open={coApplicantInfoOpen}
        setOpen={setCoApplicantInfoOpen}
        language="fi"
      />
    </div>
  );
};
